import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
        <g transform="matrix(1, 0, 0, 1, 35, 45)">
          <g fill="#5ce1e6" fillOpacity="1">
            <g transform="translate(0.990589, 32.525359)">
              <g>
                <path
                  d="M 5.375 -0.25 L 10.65625 -0.25 C 12.425781 -0.25 13.894531 -0.3125 15.0625 -0.4375 C 16.238281 -0.570312 17.289062 -0.859375 18.21875 -1.296875 C 19.15625 -1.742188 20.140625 -2.441406 21.171875 -3.390625 L 21.171875 0 L 1.5 0 L 17.46875 -30.015625 L 12.015625 -30.015625 C 10.273438 -30.015625 8.816406 -29.960938 7.640625 -29.859375 C 6.460938 -29.765625 5.410156 -29.507812 4.484375 -29.09375 C 3.554688 -28.675781 2.5625 -27.976562 1.5 -27 L 1.5 -30.359375 L 21.515625 -30.359375 Z M 5.375 -0.25 "
                  fill="currentColor"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default IconLogo;
